<div *ngIf="loading; else loaded">Loading...</div>

<ng-template #loaded>
  <div *ngIf="emergencyContactAudits && emergencyContactAudits.length > 0; else noAudits">
    <sd-portal-audit-detail-list [audits]="emergencyContactAudits" (nextPage)="onNextPage()">
    </sd-portal-audit-detail-list>
  </div>
  <ng-template #noAudits> No Emergency Contact audits </ng-template>

  <mat-accordion>
    <mat-expansion-panel
      *ngFor="let emergencyContactPhoneNumberSkeleton of emergencyContact.phoneNumbers"
      (opened)="emergencyContactPhoneNumberAuditOpened(emergencyContactPhoneNumberSkeleton)"
    >
      <mat-expansion-panel-header>
        Phone Number #{{ emergencyContactPhoneNumberSkeleton.phoneNumber }}
      </mat-expansion-panel-header>
      <ng-template matExpansionPanelContent>
        <sd-portal-person-profile-emergency-contact-phone-number-audit-list
          #emergencyContactPhoneNumberAuditList
          [emergencyContactPhoneNumber]="emergencyContactPhoneNumberSkeleton"
          [loading]="emergencyContactPhoneNumberAuditsLoading"
          [emergencyContactPhoneNumberAudits]="emergencyContactPhoneNumberAudits"
          (loadEmergencyContactPhoneNumberAudits)="
            loadEmergencyContactPhoneNumberAudits.emit($event)
          "
          (nextPage)="nextEmergencyContactPhoneNumberAuditPage.emit($event)"
        >
        </sd-portal-person-profile-emergency-contact-phone-number-audit-list>
      </ng-template>
    </mat-expansion-panel>
  </mat-accordion>
</ng-template>
